import { Row, Col } from 'antd';
import styled from 'styled-components';
import { DEFAULT_RISK_RPN_COLOR } from '@/utils/constants';

export const RequiredElementRow = styled(Row)`
	font-size: 1rem;
	overflow: hidden;
	border-radius: 6px;
	border: 2px solid #e6e8e8;
`;

export const ElementNameCol = styled(Col)`
	color: #fff;
	font-weight: bold;
	padding: 0.5rem 1.2rem;
	background-color: ${DEFAULT_RISK_RPN_COLOR};
`;

export const ElementActionCol = styled(Col)`
	padding: 0.5rem 0 0.5rem 1rem;
`;

export const ElementScorePriorityCol = styled(Col)`
	padding: 0.5rem;
	text-align: center;
	border-left: 2px solid #e6e8e8;
`;
